import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import CompanyLogo from '../VacancyCard/CompanyLogo';

const TrustedUs = ({ partners }) => {
  const { t } = useTranslation();

  return (
    <div className={`container`}>
      <div className="row">
        {partners.map(item => (
          <CompanyCard item={item} />
        ))}
      </div>
    </div>
  );
};

export default TrustedUs;

export const CompanyCard = ({ item }) => {
  return (
    <div className="pt-1 col-6 col-sm-6 col-md-4 col-lg-2 mb-4" key={item?.id}>
      <a
        href={`https://m-career.uwed.uz/all-companies/${item?.id}`}
        target={'_blank'}
        className={'text-black text-center'}
        style={{ textDecoration: 'none' }}
      >
        <div className={styles.trustedCard}>
          <div className={styles.trustedImage}>
            <CompanyLogo logo={item?.logo} companyName={item?.companyName} />
          </div>
          <h4 className={styles.trustedTitle}>{item?.name}</h4>
        </div>
      </a>
    </div>
  );
};
